import services from 'services/services';
import * as types from '../types';
import { setRequestUrl } from 'store/actions';
import { parse, format, endOfDay } from 'date-fns';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../helpers_actions/convert_helpers';

// ******************** FETCH EPG - TABLE DATA ********************
export const fetchEpg = (options, itemId) => async (dispatch, getState) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_EPG_LOADING,
			payload: true
		});

		const {
			filtered: { date }
		} = options;

		const {
			epg: {
				table: {
					columns,
					options: {
						filters: { filterUrlQuery },
						startIndex: startTableIndex,
						page
					}
				}
			}
		} = getState();

		const startIndex =
			options.page === page ? startTableIndex : options.startIndex;

		const parsedDate = parse(date, 'yyyy-M-d', new Date());
		const date_from = format(parsedDate, 'YYYYMMDDHHmmss');
		const date_to = format(endOfDay(parsedDate), 'YYYYMMDDHHmmss');
		const url = `products/programs?date_from=${date_from}&date_to=${date_to}&parent_uuid=${itemId}&${filterUrlQuery}${queryParams(
			options,
			TABLE_LENGTH,
			columns,
			startIndex
		)}`;

		const { data } = await services.get(url);

		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_EPG_SUCCESS,
			payload: { ...data, pages, page: options.page, startIndex }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_EPG_ERROR,
			payload: true
		});
	}
};

// ******************** SEND EPG TO BLACKLIST ********************
export const updateEpgBlacklist = (data, apiSlug) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.SEND_EPG_TO_BLACKLIST_LOADING,
			payload: true
		});

		await services.post(`/channel/programs/blackout/${apiSlug}`, data);
		// Dispatch an action with data
		dispatch({
			type: types.SEND_EPG_TO_BLACKLIST_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.SEND_EPG_TO_BLACKLIST_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** SET SEARCH QUERY ********************
export const setEpgQuery = (query) => ({
	type: types.SET_EPG_SEARCH_QUERY,
	payload: query
});

// ******************** SET EPG DATE ********************
export const setEpgDate = (date) => ({
	type: types.SET_EPG_DATE,
	payload: date
});
